
import React from 'react';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import get from 'lodash/get';

const ParameterComboBox = ({
    id,
    options,
    title,
    value,
    values,
    onChangeValue
}) => {

    const emptyValue = get(options, 'ComboBox.emptyValue');

    const allowFreeText = () => {
        return (values.length > 0) && (values[0].length === 1);
    }

    const getOptions = () => {
        const items = [
            ...(emptyValue
                ? [emptyValue]
                : []
            ),
            ...values.map(item => {
                return {
                    key: item[0],
                    text: (item.length > 1) ? item[1] : item[0]
                };
            })
        ];
        return items;
    }

    const getSelectedValue = () => {
        return value
            ? value
            : emptyValue
                ? emptyValue.key
                : null;
    }

    const handleChange = (evt, option, index, value) => {
        if (onChangeValue) {
            const returnedValue = option ? option.key : allowFreeText() ? value : null;
            onChangeValue(
                id, returnedValue
            );
        }
    }

    return (
        <ComboBox
            allowFreeform={true}
            label={title}
            onChange={handleChange}
            options={getOptions()}
            placeholder={allowFreeText() ? 'Vyberte hodnotu ze seznamu nebo zadejte text' : 'Vyberte hodnotu ze seznamu'}
            selectedKey={getSelectedValue()}
            styles={get(options, 'ComboBox.styles')}
            text={allowFreeText() ? value : null}
            useComboBoxAsMenuWidth={true}
        />
    );
}

export default ParameterComboBox;
